export default __webpack_public_path__ + "static/media/mariaFilo_mob_banner_1.0d663a00.jpg";